import { Route, Routes } from "react-router";

import {
  FestivalCardRedirect,
  FestivalRecordRedirect,
} from "@/pages/tina/festivals/components/redirects";
import { FestivalsList } from "@/pages/tina/festivals/list";
import { FestivalPage } from "@/pages/tina/festivals/page";

/**
 * Everything under `/tina/festivals`: the list and one festival's page. The old card and record urls (a Discord
 * message, a bookmark) open the festival's page.
 */
export const FestivalRoutes = () => (
  <Routes>
    <Route index element={<FestivalsList />} />
    <Route path="cards/:id" element={<FestivalCardRedirect />} />
    <Route path="records/:id" element={<FestivalRecordRedirect />} />
    <Route path=":id" element={<FestivalPage />} />
  </Routes>
);
